module.exports = __webpack_public_path__ + "static/media/portfolio-1.2a45e00b.jpg";